import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

// eslint-disable-next-line @nx/enforce-module-boundaries
import { PipesModule } from "@intocare/pipes";

import { ButtonModule } from "../button/button.module";
import { EmptyStateComponent } from "./components/empty-state/empty-state.component";
import { EmptyStateLandingPageComponent } from "./components/empty-state-landing-page/empty-state-landing-page.component";

@NgModule({
	declarations: [EmptyStateComponent, EmptyStateLandingPageComponent],
	imports: [CommonModule, ButtonModule, PipesModule],
	exports: [EmptyStateComponent, EmptyStateLandingPageComponent],
})
export class EmptyStateModule {}
